import { EDIT_LISTING_NUM_OF_GUESTS,
         CLOSE_LISTING_NUM_OF_GUESTS,
         PENDING_SUBMIT_LISTING_NUM_OF_GUESTS,
         COMPLETE_SUBMIT_LISTING_NUM_OF_GUESTS,
         FAILED_SUBMIT_LISTING_NUM_OF_GUESTS
    } from "./mlTypes"


const initialState = {
    pendingsubmit: false,
    failedsubmit: false,
    completesubmit: false,
    propertynumofguestsediting: false
}


const mlListingNumOfGuests = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_LISTING_NUM_OF_GUESTS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertynumofguestsediting: true
        }

        case CLOSE_LISTING_NUM_OF_GUESTS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertynumofguestsediting: false
        }

        case PENDING_SUBMIT_LISTING_NUM_OF_GUESTS: return {
            ...state,
            pendingsubmit: true,
            failedsubmit: false,
            completesubmit: false
        }

        case COMPLETE_SUBMIT_LISTING_NUM_OF_GUESTS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: true
        }
        
        case FAILED_SUBMIT_LISTING_NUM_OF_GUESTS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: true,
            completesubmit: true
        }
    
        default: return state
    }
}

export default mlListingNumOfGuests